// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-card{padding:60px;background:#fff;border-radius:5px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.1)}@media (max-width:768px){.a-card{border-radius:0}}", ""]);
// Exports
module.exports = exports;
